export const playlistBiteItemCy = 'playlist-bite-item';
